import {
    IconDatabase,
    IconSettings,
    IconAdjustmentsCog,
    IconChartArea,
    IconVocabulary,
    IconTool,
    IconCodeAsterix, IconHeartRateMonitor, IconVectorBezier2, IconUsers,
    IconSubtitlesEdit, IconNotebook, IconServer, IconRoute
} from '@tabler/icons-react'
import {IconNeo4j} from "../../../components/icons/IconNeo4j";
import {IconPhonePlay} from "../../../components/icons/IconPhonePlay";
import {grey} from "@mui/material/colors";

export const sidebarMenuItems = [
    {
        label: "Dashboard",
        icon: <IconChartArea stroke={1.5}/>,
        to: (project) => `/project/${project?.id}`,
        roles: ["ADMIN", "MANAGER", "AGENT"]
    },
    {
        label: "Supervision",
        icon: <IconNotebook stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/supervision`,
        roles: ["ADMIN", "MANAGER", "AGENT"]
    },
    {
        label: "Designer",
        icon: <IconVectorBezier2 stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/flow`,
        roles: ["ADMIN", "MANAGER"]
    },
    {
        label: "Message Annotation",
        icon: <IconSubtitlesEdit stroke={1.5}/>,
        to: (project) => `/project/${project?.id}/message-annotations`,
        roles: ["ADMIN", "MANAGER", "ANNOTATOR"]
    },
    {
        label: "Knowledge Base",
        icon: <IconDatabase stroke={1.5}/>,
        roles: ["ADMIN", "MANAGER"],
        hideOnMobile: true,
        submenu: [
            {
                label: "MCP Registry",
                icon: <IconServer stroke={1.5}/>,
                to: (project) => `/project/${project?.id}/mcp-registry`,
                roles: ["ADMIN", "MANAGER"]
            },
            {
                label: "Knowledge Manager",
                icon: <IconDatabase stroke={1.5}/>,
                to: (project) => `/project/${project?.id}/knowledge-manager`,
                disabled: (project) => !project.settings?.organization,
                roles: ["ADMIN", "MANAGER"]
            },

        ]
    },
    {
        label: "Settings",
        icon: <IconSettings stroke={1.5}/>,
        roles: ["ADMIN", "MANAGER"],
        submenu: [
            {
                label: "Project Settings",
                icon: <IconTool/>,
                to: (project) => `/project/${project?.id}/settings`,
                roles: ["ADMIN", "MANAGER"]
            },
            {
                label: "Voice Configuration",
                icon: <IconAdjustmentsCog/>,
                to: (project) => `/project/${project?.id}/configuration`,
                roles: ["ADMIN", "MANAGER"]
            },
            {
                label: "Vocabulary",
                icon: <IconVocabulary stroke={1.5}/>,
                to: (project) => `/project/${project?.id}/vocabulary`,
                roles: ["ADMIN", "MANAGER", "AGENT"]
            },
            {
                label: "SIP Configuration",
                icon: <IconCodeAsterix/>,
                to: (project) => `/project/${project?.id}/sip`,
                roles: ["ADMIN"]
            },
            {
                label: "SIP Dialplan",
                icon: <IconRoute stroke={1.5}/>,
                to: (project) => `/project/${project?.id}/dialplan`,
                roles: ["ADMIN"]
            },
        ]
    }
];
